import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html'
})
export class ContentComponent implements OnInit {

  showHeader = true;
  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      // Check current route and update the visibility of the header
      const currentRoute = this.router.url;
      this.showHeader = currentRoute === '/m-quotation' || currentRoute === '/m-quotation/create-project';
    });
   }

  ngOnInit(): void {
  }

}
